export const NORMAL = "NORMAL";
export const REVIEW = "REVIEW";
export const HIGHLIGHT = "HIGHLIGHT";
export const CATCH = "CATCH";
export const CATCHSTORY = "CATCHSTORY";